module.exports = __webpack_public_path__ + "media/img/illustrations/icons/table-escalation-alert-dc3b3bbe4bc59fc3591c81a881a4cd5a.svg";